<template>
  <div>
    <div class="dropdown" :class="{ 'is-up': tagDropup }" style="width: 100%">
      <BInputWithValidation
        rules="max:30"
        type="text"
        label="Tags"
        v-model="tagName"
        iconRight="plus-square"
        iconRightClickable
        @iconRightClicked="createTag"
        style="width: 100%"
      />
      <div
        class="dropdown-menu"
        :class="{ 'is-block': tagName && filteredTagName.length }"
      >
        <div class="dropdown-content">
          <a
            v-for="tag in filteredTagName"
            :key="tag.id"
            href="#"
            class="dropdown-item"
            @click.prevent="addExistingTag(tag)"
          >
            {{ tag.name }}
          </a>
        </div>
      </div>
    </div>
    <b-taglist v-if="value.length" class="route-tag mt-4">
      <b-tag
        v-for="tag in value"
        :key="tag.id"
        closable
        @close="removeTag(tag.id)"
      >
        {{ tag.name }}
      </b-tag>
    </b-taglist>
    <div v-else style="height: 40px">&nbsp;</div>
  </div>
</template>

<script>
import BInputWithValidation from '@/components/inputs/BInputWithValidation.vue';
import { mapState } from 'vuex';

export default {
  name: 'RouteTagInput',
  components: { BInputWithValidation },
  props: {
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
    tagDropup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tagName: '',
      valueCopy: [...this.value],
      tagCreated: false,
    };
  },
  computed: {
    ...mapState({
      // Gonna be watched for tag addition
      tags: (state) => state.tag.data,
    }),
    tagsArray() {
      return Object.values(this.tags);
    },
    filteredTagName() {
      return this.tagsArray.filter(
        (option) => option.name
          .toString()
          .toLowerCase()
          .indexOf(this.tagName.toLowerCase()) >= 0,
      );
    },
  },
  watch: {
    tags: {
      deep: true,
      handler: 'addCreatedTag',
    },
    value(newVal) {
      this.valueCopy = [...newVal];
    },
  },
  methods: {
    createTag() {
      // Prevent adding empty tag
      if (!this.tagName) return;
      this.$store.dispatch('tag/CREATE', { name: this.tagName });
      this.tagCreated = true;
      this.tagName = '';
    },
    addCreatedTag(newVal) {
      console.log('addCreatedTag', newVal);
      if (!this.tagCreated) return;
      const newTag = this.getLatestTag(newVal);
      this.valueCopy.push(newTag);
      this.$emit('input', this.valueCopy);
    },
    addExistingTag(tag) {
      console.log('addExistingTag', tag);
      this.valueCopy.push(tag);
      this.tagName = '';
      this.$emit('input', this.valueCopy);
    },
    removeTag(tagId) {
      this.valueCopy = this.valueCopy.filter((tag) => tag.id !== tagId);
      this.$emit('input', this.valueCopy);
    },
    getLatestTag(tags) {
      const tagIds = Object.keys(tags);
      const latestId = parseInt(tagIds[tagIds.length - 1], 10);
      return tags[latestId];
    },
  },
};
</script>

<style>
.tags.route-tag .tag .delete.is-small {
  margin-top: -25px;
}
.tags.route-tag .tag:not(body) {
  padding-right: 0 !important;
}
</style>
